/**
 * Predictive search — debounced fetch against Shopify's predictive search
 * endpoint, requesting the pre-styled `predictive-search` section HTML
 * directly (Section Rendering API) so no client-side templating is needed.
 * Also manages "Recent searches" via localStorage and renders it, plus a
 * static "Trending" / "Popular categories" default state when the field
 * is empty.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'wallz:recentSearches';
  var TRENDING = ['Anime Posters', 'Football Legends', 'Devotional Wall Art', 'Gaming Room Decor', 'Luxury Cars'];
  var POPULAR_CATEGORIES = [
    { label: 'Anime', url: '/collections/anime' },
    { label: 'Football', url: '/collections/football' },
    { label: 'Cars', url: '/collections/cars' },
    { label: 'Devotional', url: '/collections/devotional' },
    { label: 'Gaming', url: '/collections/gaming' },
  ];

  function renderDefaultState(container) {
    var recent = WallZ.utils.getStorage(RECENT_KEY, []);
    var html = '';
    if (recent.length) {
      html += '<div class="predictive-search__group"><p class="predictive-search__group-title">' + WallZ.strings.recentSearches + ' <button type="button" class="link-underline" data-clear-recent" style="font-weight:400;font-size:0.72rem;">' + WallZ.strings.clearRecent + '</button></p><ul>' +
        recent.map(function (term) { return '<li><a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="predictive-search__collection-link">' + term + '</a></li>'; }).join('') +
        '</ul></div>';
    }
    html += '<div class="predictive-search__group"><p class="predictive-search__group-title">' + WallZ.strings.trending + '</p><ul>' +
      TRENDING.map(function (term) { return '<li><a href="/search?q=' + encodeURIComponent(term) + '&type=product" class="predictive-search__collection-link">' + term + '</a></li>'; }).join('') +
      '</ul></div>';
    html += '<div class="predictive-search__group"><p class="predictive-search__group-title">' + WallZ.strings.popularCategories + '</p><ul class="predictive-search__chip-list">' +
      POPULAR_CATEGORIES.map(function (c) { return '<li><a href="' + c.url + '" class="badge badge--outline">' + c.label + '</a></li>'; }).join('') +
      '</ul></div>';
    container.innerHTML = html;
    var clearBtn = container.querySelector('[data-clear-recent]');
    if (clearBtn) clearBtn.addEventListener('click', function () { WallZ.utils.setStorage(RECENT_KEY, []); renderDefaultState(container); });
  }

  function saveRecentSearch(term) {
    if (!term || term.trim().length < 2) return;
    var recent = WallZ.utils.getStorage(RECENT_KEY, []);
    recent = recent.filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    recent.unshift(term.trim());
    WallZ.utils.setStorage(RECENT_KEY, recent.slice(0, 6));
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.WallZ.strings = window.WallZ.strings || {};
    Object.assign(window.WallZ.strings, {
      recentSearches: window.WallZ.strings.recentSearches || 'Recent searches',
      clearRecent: window.WallZ.strings.clearRecent || 'Clear',
      trending: window.WallZ.strings.trending || 'Trending searches',
      popularCategories: window.WallZ.strings.popularCategories || 'Popular categories',
    });

    var input = document.querySelector('[data-predictive-search-input]');
    var results = document.querySelector('[data-predictive-search-results]');
    var form = input ? input.closest('form') : null;
    if (!input || !results) return;

    renderDefaultState(results);

    var controller;
    var fetchResults = WallZ.utils.debounce(function (term) {
      if (!term) { renderDefaultState(results); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      results.classList.add('is-loading');
      fetch('/search/suggest' + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search', { signal: controller.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('[data-predictive-search-section]');
          results.innerHTML = section ? section.innerHTML : '';
          results.classList.remove('is-loading');
        })
        .catch(function () { results.classList.remove('is-loading'); });
    }, 220);

    input.addEventListener('input', function () { fetchResults(input.value.trim()); });
    if (form) {
      form.addEventListener('submit', function () { saveRecentSearch(input.value.trim()); });
    }
  });
})();
